import React from 'react';
import { capitalize } from '@/common/helper';
import { ActivityEvent } from '../../types';

interface ActivityRowProps {
  event: ActivityEvent;
  time: string;
  actorName?: string;
  onActorClick?: () => void;
  onRowClick?: () => void;
}

const ActivityRow: React.FC<ActivityRowProps> = ({
  event,
  time,
  actorName,
  onActorClick,
  onRowClick, // for clickable events, notificaiton, comment, alerts
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    onRowClick?.();
  };

  return (
    <div
      className={`activity-row ${onRowClick ? 'cursor-pointer' : ''}`}
      data-activity-id={event?.id}
      onClick={onRowClick}
      role={onRowClick ? 'button' : undefined}
      tabIndex={onRowClick ? 0 : undefined}
      onKeyDown={onRowClick ? handleKeyDown : undefined}
    >
      {/*activity timeline dot*/}
      <span className='activity-row-dot' />
      <div className='activity-row-body'>
        <div className='activity-row-top'>
          <div className='activity-row-text'>
            {actorName && (
              <span
                className='activity-row-actor'
                onClick={(e) => {
                  e.stopPropagation();
                  onActorClick?.();
                }}
              >
                {capitalize(actorName)}
              </span>
            )}
            <span className='activity-row-action'>
              {actorName ? event?.action : capitalize(event?.action)}
            </span>
          </div>
          <span className='activity-row-time'>{time}</span>
        </div>
        <div className='activity-row-detail'>{event?.detail}</div>
      </div>
    </div>
  );
};

export default ActivityRow;
